<template>
  <main>
    <VSpin :value="true"/>
  </main>
</template>
<script>
  import VSpin from '@/components/VSpin.vue'
  import { paymentFailMessage, redirectPostMessage } from '@/app/commands/pagesCommands'

  export default {
    name: 'PaymentFailPrepare',
    components: {
      VSpin,
    },
    mounted() {
      const failMessage = this.$route.query ? this.$route.query.Message : undefined
      redirectPostMessage({ title: paymentFailMessage, description: failMessage || '' })
    },
  }
</script>
<style lang="scss">

</style>
